export * from './podcastContentP';
export * from './podcastGroupP';
export * from './podcastP';
export * from './responseObj';
export * from './responseObjOfListOfPodcastGroupP';
export * from './responseObjOfListOfPodcastP';
export * from './responseObjOfPodcastGroupP';
export * from './responseObjOfPodcastP';
export * from './timestamp';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/podcast-content-client-api/model/models.ts